{
  "header": {
    "title": "Historial de preguntas",
    "description": "Revise y analice las respuestas de retroalimentación anteriores"
  },
  "emptyState": {
    "company": {
      "title": "No se han recopilado datos aún",
      "description": "¡Tu viaje comienza aquí! Una vez que los empleados empiecen a compartir sus opiniones durante el primer mes, verás aparecer conocimientos y tendencias"
    },
    "directReports": {
      "title": "Sin subordinados directos",
      "description": "No tienes subordinados directos asignados, ¡pero aún puedes participar en encuestas y compartir comentarios valiosos!",
      "bottomAction": {
        "label": "Si crees que esto es un error, contacta con tu gerente",
        "helpText": "Texto de ayuda"
      }
    }
  },
  "NotEnoughResponse": {
    "title": "No hay suficientes respuestas aún",
    "description": "La puntuación se mostrará una vez que se hayan recopilado al menos 3 respuestas"
  },
  "tabs": {
    "company": "Toda la empresa",
    "allReports": "Todos los informes",
    "directReports": "Informes directos",
    "myTeam": "Mi equipo"
  },
  "leaderDropdown": {
    "triggerLabel": "Líder",
    "searchPlaceholder": "Buscar un líder"
  },
  "categoryDropdown": {
    "triggerLabel": "Categorías"
  },
  "detailsPage": {
    "header": {
      "description": "Revise y analice respuestas anteriores de retroalimentación",
      "exportButton": "Exportar",
      "backButton": "Volver al Historial de Preguntas"
    },
    "tabs": {
      "company": "Toda la empresa",
      "allReports": "Todos los informes",
      "directReports": "Informes directos",
      "myTeam": "Mi equipo"
    },
    "leaderDropdown": {
      "triggerLabel": "Líder",
      "searchPlaceholder": "Buscar un líder"
    },
    "satisfactionScoreSection": {
      "title": "Puntuación de satisfacción",
      "barChart": {
        "title": "Distribución de respuestas",
        "agreeTitle": "De acuerdo",
        "somewhatAgreeTitle": "Algo de acuerdo",
        "neutralTitle": "Neutral",
        "somewhatDisagreeTitle": "Algo en desacuerdo",
        "disagreeTitle": "En desacuerdo"
      }
    },
    "directReportSection": {
      "title": "Equipo del informe directo",
      "empty": {
        "title": "No hay líderes de informes directos",
        "description": "Este líder no tiene líderes subordinados, o los datos aún no se han cargado."
      }
    },
    "participationRateSection": {
      "title": "Tasa de participación"
    },
    "responsesCount_one": "{{count}} respuesta",
    "responsesCount_other": "{{count}} respuestas",
    "previousResponseSection": {
      "title": "Respuesta anterior"
    },
    "enps": {
      "categoryName": "eNPS",
      "questionText": "¿Qué probabilidad hay de que recomiendes trabajar en nuestra empresa?",
      "scoreSection": {
        "title": "Puntuación eNPS",
        "companyAverage": "Promedio de la empresa: {{score}}",
        "tooltip": {
          "description": "El Employee Net Promoter Score (eNPS) se calcula encuestando a los empleados en una escala de 0 a 10:",
          "promoters": "Promotores (9-10)",
          "passives": "Pasivos (7-8)",
          "detractors": "Detractores (0-6)",
          "formulaLabel": "La fórmula es:",
          "formula": "% Promotores - % Detractores = eNPS",
          "resultRange": "El resultado va de -100 a 100, donde una puntuación más alta es mejor. Los pasivos se excluyen del cálculo final."
        }
      },
      "distribution": {
        "title": "Distribución de respuestas",
        "subtitle": "Número de respuestas",
        "detractors": "Detractores ({{percentage}}%)",
        "passives": "Pasivos ({{percentage}}%)",
        "promoters": "Promotores ({{percentage}}%)",
        "xAxisLabel": "Puntuación de respuesta"
      },
      "trendSection": {
        "title": "eNPS a lo largo del tiempo",
        "subtitle": "Desglose de 6 meses",
        "yourTeam": "Tu equipo",
        "companyAverage": "Promedio de la empresa"
      },
      "directReportSection": {
        "title": "Equipo del informe directo",
        "teamTitle": "Equipo de {{leaderName}}"
      },
      "previousResponseSection": {
        "title": "Respuesta anterior",
        "columns": {
          "date": "Fecha",
          "score": "Puntuación eNPS",
          "responsePercentage": "Porcentaje de respuestas"
        }
      }
    }
  }
}
